enum SupportTranslationVariant {
  header = 'header',
  description = 'description',
  videoSections = 'videoSections',
  overview = 'overview',
  howToLessonPlanner = 'howToLessonPlanner',
  resources = 'resources',
  app = 'app',
  didntFind = 'didntFind',
  navigationMap = 'navigationMap',
  navigationMapDescription = 'navigationMapDescription',
  documents = 'documents',
  iconLegend = 'iconLegend',
  iconLegendDescription = 'iconLegendDescription',
  contact = 'contact',
  contactEmail = 'contactEmail',
  contactDescription = 'contactDescription',
  officeHours1 = 'officeHours1',
  officeHours2 = 'officeHours2',
  phone = 'phone',
  email = 'email',
  download = 'download',
  clickAway = 'clickAway',
  clickAwayDescription = 'clickAwayDescription',
  animations = 'animations',
  animationsDescription = 'animationsDescription',
  connections = 'connections',
  connectionsDescription = 'connectionsDescription',
  letterFormation = 'letterFormation',
  letterFormationDescription = 'letterFormationDescription',
  liveTeaching = 'liveTeaching',
  liveTeachingDescription = 'liveTeachingDescription',
  matman = 'matman',
  matmanDescription = 'matmanDescription',
  music = 'music',
  musicDescription = 'musicDescription',
  wdt = 'wdt',
  wdtDescription = 'wdtDescription',
  woodPieces = 'woodPieces',
  woodPiecesDescription = 'woodPiecesDescription',
  name = 'name',
  message = 'message',
  submit = 'submit'
}

export default SupportTranslationVariant;
